import FlexPane from 'presentation/components/flex-pane/index.js';
import Button from 'presentation/components/button/index.js';
import SportIcon from 'presentation/components/sport-icon/index.js';
import Text from 'presentation/components/text/index.js';
import SportWatermarkImage from 'presentation/components/sport-watermark-image/index.js';

const FallbackEventCard = props => {
    const {
        mojitoTools: { config, stringResolver },
        headerTitle,
        contentText,
        sportId,
        onClick,
        onClickData,
    } = props;

    return (
        <FlexPane class="ta-FallbackEventCard" config={config.eventCardBase.container}>
            <SportIcon config={config.sportIcon} sportId={sportId} />
            {config.showBackgroundSportImage && (
                <SportWatermarkImage sportId={sportId} config={config.sportWatermark} />
            )}
            <FlexPane config={config.contentContainer}>
                <Text class="ta-headerTitle" config={config.eventCardBase.title}>
                    {headerTitle}
                </Text>
                <Text class="ta-contentText" config={config.contentText}>
                    {contentText}
                </Text>
                <FlexPane config={config.betNowContainer}>
                    <Button config={config.betNowButton} onClick={() => onClick(onClickData)}>
                        {stringResolver.resolveAndFormatString('$FALLBACK_CARD.BET_NOW')}
                    </Button>
                </FlexPane>
            </FlexPane>
        </FlexPane>
    );
};

export default FallbackEventCard;
